import { render } from "./ServiceRequestDetails.vue?vue&type=template&id=50fa244d&scoped=true"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=js"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=js"

import "./ServiceRequestDetails.vue?vue&type=style&index=0&id=50fa244d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fa244d"]])

export default __exports__